<div class="atn-space-cluster-assigned-records">
  <atn-ds-table [config]="tableConfig" />
</div>

@if (
  assignedRecordsEc.plugins.currentEntityPlugin.feature.selectors
    .isCreating()
    .asSignal()
) {
  <atn-space-assign-records-to-cluster-modal />
}

@if (
  assignedRecordsEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()
) {
  <atn-ds-confirmation-overlay
    title="Delete Record Assignment"
    description="Deleting record assignment from the cluster can't be undone. Are you sure you want to delete this record assignment?"
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
    confirmButtonText="Delete"
  />
}
